module.exports = __webpack_public_path__ + "static/media/experience.adace39e.svg";